<template>
  <MdMenu md-size="medium" md-align-trigger>
    <MdBadge class="md-square" :mdContent="numClients"
      v-bind:class="{'hide-one': numClients <= 1}">
      <MdButton class="md-icon-button" md-menu-trigger>
        <MdIcon class="fas fa-user" />
      </MdButton>
    </MdBadge>

    <MdMenuContent>
      <MdMenuItem v-for="c in clients" :key="c.uid">
        <span class="display-name">{{ c.displayName }}</span>
        <i v-if="c.self">(you)</i>
        <i v-else-if="c.host">(host)</i>
      </MdMenuItem>
    </MdMenuContent>

    <MdSnackbar
      md-position="center"
      :md-active.sync="reportNewClients"
      @md-closed="onNewClientsReported"
    >
      <span v-if="reportedClients.length === 1">
        {{ reportedClients[0].displayName }} has connected
      </span>
      <span v-else>
        New clients connected: {{ reportedClients.map(u => u.displayName).join(', ') }}
      </span>
    </MdSnackbar>
    <MdSnackbar
      md-position="center"
      :md-active.sync="reportGoneClients"
      @md-closed="onGoneClientsReported"
    >
      <span v-if="reportedClients.length === 1">
        {{ reportedClients[0].displayName }} has disconnected
      </span>
      <span v-else>
        Some clients disconnected: {{ reportedClients.map(u => u.displayName).join(', ') }}
      </span>
    </MdSnackbar>
  </MdMenu>
</template>

<script>
import differenceBy from 'lodash/differenceBy';

export default {
  props: {
    user: { type: Object, required: true },
    clients: { type: Array, required: true },
  },

  data() {
    return {
      reportNewClients: false,
      reportGoneClients: false,
      reportedClients: [],
      newClients: [],
      goneClients: [],
    };
  },

  computed: {
    numClients() {
      return this.clients.length;
    },
  },

  watch: {
    clients(newVal, oldVal) {
      if (!oldVal.length) {
        // This is the first time we get the clients, do nothing
        return;
      }

      const newClients = differenceBy(newVal, oldVal, u => u.uid);
      this.newClients = this.newClients.concat(newClients);
      const goneClients = differenceBy(oldVal, newVal, u => u.uid);
      this.goneClients = this.goneClients.concat(goneClients);
      this.reportClientChanges();
    },
  },

  methods: {
    reportClientChanges() {
      this.onNewClientsReported();
    },

    onNewClientsReported() {
      // Wait until all snackbars are closed
      if (this.reportNewClients || this.reportGoneClients) {
        return;
      }

      // First show the gone clients
      if (this.goneClients.length > 0) {
        this.reportGoneClients = true;
        this.reportedClients = this.goneClients;
        this.goneClients = [];
        return;
      }

      // Then show the new clients
      if (this.newClients.length > 0) {
        this.reportNewClients = true;
        this.reportedClients = this.newClients;
        this.newClients = [];
        return;
      }
    },

    onGoneClientsReported() {
      // Wait until all snackbars are closed
      if (this.reportNewClients || this.reportGoneClients) {
        return;
      }

      // First show the new clients
      if (this.newClients.length > 0) {
        this.reportNewClients = true;
        this.reportedClients = this.newClients;
        this.newClients = [];
        return;
      }

      // Then show the gone clients
      if (this.goneClients.length > 0) {
        this.reportGoneClients = true;
        this.reportedClients = this.goneClients;
        this.goneClients = [];
        return;
      }
    },
  },
};
</script>

<style>
.md-badge-content.md-square.hide-one .md-badge.md-square {
  display: none;
}

.md-list-item-content .display-name {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
